const FIRST_INDEX = 0;
const MIN_SWIPEABLE_ITEMS = 2;
const SWIPE_THRESHOLD_PX = 40;
const PRIMARY_MOUSE_BUTTON = 0;
const SWIPE_PREV = -1;
const SWIPE_NEXT = 1;
const WHEEL_SWIPE_THRESHOLD_PX = 50;
const WHEEL_COOLDOWN_MS = 350;

export class CountdownBarSwipeController {
  private pointerStartX = 0;
  private pointerStartY = 0;
  private wheelDeltaX = 0;
  private wheelCooldown = false;
  private wheelCooldownTimer: ReturnType<typeof setTimeout> | undefined;

  swipeConsumed = false;

  constructor(private readonly changeSlide: (direction: number) => void) {}

  destroy(): void {
    clearTimeout(this.wheelCooldownTimer);
  }

  onPointerDown(event: PointerEvent): void {
    if (event.pointerType === 'mouse' && event.button !== PRIMARY_MOUSE_BUTTON) {
      return;
    }

    this.pointerStartX = event.clientX;
    this.pointerStartY = event.clientY;
    this.swipeConsumed = false;
  }

  onPointerUp(event: PointerEvent, itemsCount: number): void {
    if (itemsCount < MIN_SWIPEABLE_ITEMS) {
      return;
    }

    const deltaX = event.clientX - this.pointerStartX;

    if (!this.isHorizontalSwipe(deltaX, event.clientY - this.pointerStartY)) {
      return;
    }

    this.swipeConsumed = true;
    this.changeSlide(deltaX < FIRST_INDEX ? SWIPE_NEXT : SWIPE_PREV);
  }

  onWheel(event: WheelEvent, itemsCount: number): void {
    if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) {
      return;
    }

    event.preventDefault();

    if (this.shouldIgnoreWheel(itemsCount)) {
      return;
    }

    this.wheelDeltaX += event.deltaX;

    if (Math.abs(this.wheelDeltaX) < WHEEL_SWIPE_THRESHOLD_PX) {
      return;
    }

    this.changeSlide(this.wheelDeltaX > FIRST_INDEX ? SWIPE_NEXT : SWIPE_PREV);
    this.wheelDeltaX = 0;
    this.wheelCooldown = true;
    clearTimeout(this.wheelCooldownTimer);

    this.wheelCooldownTimer = setTimeout(() => {
      this.wheelCooldown = false;
    }, WHEEL_COOLDOWN_MS);
  }

  private isHorizontalSwipe(deltaX: number, deltaY: number): boolean {
    return Math.abs(deltaX) >= SWIPE_THRESHOLD_PX && Math.abs(deltaX) > Math.abs(deltaY);
  }

  private shouldIgnoreWheel(itemsCount: number): boolean {
    return itemsCount < MIN_SWIPEABLE_ITEMS || this.wheelCooldown;
  }
}
